module.exports = __webpack_public_path__ + "static/media/rizal.0bbd8e0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/Team/rizal.jpg
// module id = 173
// module chunks = 0